export default __webpack_public_path__ + "static/media/socialfi-icon3.7e75fef1.png";